import { EmailIcon } from 'components/icons';
import { Link, Spacer } from 'components';
import { memo } from 'react';
import styles from './Contact.module.scss';

export interface ContactMailProps {
  email: string;
}

export const ContactMail = memo(({ email }: ContactMailProps) => {
  return (
    <Link
      className={styles.link}
      href={`mailto:${email}`}
      leftIcon={<EmailIcon />}
    >
      <Spacer marginLeft="7px">{email}</Spacer>
    </Link>
  );
});
